import { useAuth } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/layouts/PageHeader";
import { useSubscription } from "@/context/SubscriptionContext";
import createCheckoutSession from "@/utils/createCheckoutSession";
import { PLANS } from "@/constants/plans";

export default function Billing() {
  const { getToken } = useAuth();
  const { planName, loading } = useSubscription();

  const handleUpgrade = async (priceId) => {
    const token = await getToken();
    await createCheckoutSession(priceId, token);
  };

  return (
    <div className="px-10 py-9 max-w-[960px] mx-auto max-md:px-4 max-md:pt-5 max-md:pb-6">
      <PageHeader
        title="Billing"
        subtitle="Manage your subscription and plan."
      />

      <div className="px-10 py-9 max-w-[600px] max-md:px-4 max-md:pt-5 max-md:pb-6">
        {!loading && planName === "school" && (
          <div className="rounded-lg border border-border bg-card p-5 mb-4 text-sm text-muted-foreground">
            You are on a <span className="font-semibold text-foreground">School</span> plan
            managed by your school administrator. Individual plan upgrades are not available
            while you have an active school seat.
          </div>
        )}

        <div className="space-y-4">
          {PLANS.map((plan) => {
            const isCurrent = !loading && planName === plan.planKey;
            return (
              <div
                key={plan.name}
                className={`border rounded-lg p-5 bg-card flex items-center justify-between ${
                  isCurrent ? "border-primary" : "border-border"
                }`}
              >
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <p className="font-semibold text-lg">{plan.name}</p>
                    {isCurrent && (
                      <span className="text-xs bg-primary text-primary-foreground px-2 py-0.5 rounded-full">
                        Current
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{plan.price}{plan.period}</p>
                  <ul className="text-sm space-y-0.5">
                    {plan.features.map((f) => (
                      <li key={f} className="text-muted-foreground">
                        • {f}
                      </li>
                    ))}
                  </ul>
                </div>

                {!isCurrent && plan.stripePlanKey && (
                  <Button onClick={() => handleUpgrade(plan.stripePlanKey)}>Upgrade</Button>
                )}
                {!isCurrent && plan.ctaPath && (
                  <Link to={plan.ctaPath}>
                    <Button variant="outline">Set up a school</Button>
                  </Link>
                )}
              </div>
            );
          })}
        </div>

      <p className="text-xs text-muted-foreground mt-6">
        To cancel or manage your subscription, contact support. See{" "}
        <Link to="/pricing" className="underline">
          Pricing
        </Link>{" "}
        for full plan details.
      </p>
      </div>
    </div>
  );
}
